import TicTacTeo from "./Components/TicTacTeo/TicTacTeo";

function App() {
  return (
    <div>
      <TicTacTeo />
    </div>
  );
}

export default App;
